var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconOddanie2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#d6d6d6",
    stroke: "#d6d6d6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#d6d6d6;stroke-miterlimit:10;stroke-width:1.92px;}")), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "6.25 18.71 1.46 18.71 1.46 11.04 6.25 11.04"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6.25,
    y1: 14.88,
    x2: 1.46,
    y2: 14.88
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "13.92 18.71 12.96 18.71 8.17 11.04 7.21 11.04"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "7.21 18.71 8.17 18.71 12.96 11.04 13.92 11.04"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 15.83,
    y1: 10.08,
    x2: 15.83,
    y2: 19.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17.75,
    y1: 11.04,
    x2: 23.5,
    y2: 11.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 20.63,
    y1: 19.67,
    x2: 20.63,
    y2: 11.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 0.5,
    y1: 22.54,
    x2: 23.5,
    y2: 22.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 0.5,
    y1: 7.21,
    x2: 23.5,
    y2: 7.21
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "6.25 7.21 12 2.42 17.75 7.21"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12,
    cy: 2.42,
    r: 0.96
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOddanie2);
export default __webpack_public_path__ + "static/media/iconOddanie2.f7c551fe3159cfc3d1b3f8409b3d2301.svg";
export { ForwardRef as ReactComponent };